import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import filters from './filters'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/pt-br'
import VueCurrencyFilter from 'vue-currency-filter'
import VueClipboard from 'vue-clipboard2'
import infiniteScroll from 'vue-infinite-scroll'
import VueMask from 'v-mask'

Vue.use(VueClipboard)
Vue.use(infiniteScroll)
Vue.use(VueMask)

Vue.use(ElementUI, { locale })

for (const filterName in filters) {
  Vue.filter(filterName, filters[filterName])
}

Vue.config.productionTip = false

Vue.use(VueMoment, {
  moment
})

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

require('./styles/custom.sass')
require('moment/locale/pt-br')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js